export const MEMO_AREA_OPTIONS = [
  { label: "Clean all the entrance areas and lobby", value: "A" },
  { label: "Vacuum carpeted Areas", value: "B" },
  { label: "Elevator area complete cleaning", value: "C" },
  { label: "Garbage chute area complete cleaning", value: "D" },
  {
    label:
      "Sweep and mop the floors [Laundry Rooms, Lobby, and Hallways & Stains]",
    value: "E",
  },
  { label: "Clean the washer and dryer", value: "F" },
  {
    label: "Sweep and remove soil and or leave in the entrance area",
    value: "G",
  },
  {
    label:
      "Clean and dust of all areas [light, post Boxes, Entrance Areas, inside doors Areas Heaters & Inside Windows]",
    value: "H",
  },
  { label: "Inside windows", value: "I" },
  {
    label:
      "Spot cleaning the high contract areas such as walls, entrance doors and baseboards",
    value: "J",
  },
  { label: "Clean dust stair-baniste", value: "K" },
  { label: "Report unusual incident, damage or malfunction", value: "L" },
  { label: "Others", value: "M" },
];

export const MEMO_AREA_LABELS = MEMO_AREA_OPTIONS.reduce((acc, option) => {
  acc[option.value] = option.label;
  return acc;
}, {});

export const MEMO_AREA_VALUES = MEMO_AREA_OPTIONS.map((option) => option.value);
